export default {
  getTokenKey() {
    if (location.origin.includes('localhost') || location.origin.includes('dev')) {
      return 'development_sso_admin'
    }
    if (location.origin.includes('test')) {
      return 'test_sso_admin'
    }
    return 'production_sso_admin'
  },
  defaultLoadingOptions: {
    lock: true,
    text: '请稍后...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.5)'
  },
  defaultTitleEnd: '_正福易找标-你贴身的数据专家',
  IEVersion() {
    // 取得浏览器的userAgent字符串
    let userAgent = navigator.userAgent;
    // 判断是否为小于IE11的浏览器
    let isLessIE11 =
        userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1;
    // 判断是否为IE的Edge浏览器
    let isEdge = userAgent.indexOf('Edge') > -1 && !isLessIE11;
    // 判断是否为IE11浏览器
    let isIE11 =
        userAgent.indexOf('Trident') > -1 &&
        userAgent.indexOf('rv:11.0') > -1;
    if (isLessIE11) {
      var IEReg = new RegExp('MSIE (\\d+\\.\\d+);');
      // 正则表达式匹配浏览器的userAgent字符串中MSIE后的数字部分，，这一步不可省略！！！
      IEReg.test(userAgent);
      // 取正则表达式中第一个小括号里匹配到的值
      var IEVersionNum = parseFloat(RegExp['$1']);
      if (IEVersionNum === 7) {
        // IE7
        return '7';
      } else if (IEVersionNum === 8) {
        // IE8
        return '8';
      } else if (IEVersionNum === 9) {
        // IE9
        return '9';
      } else if (IEVersionNum === 10) {
        // IE10
        return '10';
      } else {
        // IE版本<7
        return '6';
      }
    } else if (isEdge) {
      // edge
      return 'edge';
    } else if (isIE11) {
      // IE11
      return '11';
    } else {
      // 不是ie浏览器
      return '0';
    }
  },
  getScrollTop() {//获取scrollTop的值，兼容所有浏览器
    let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    return scrollTop;
  },
  setScrollTop(scroll_top) {//设置scrollTop的值，兼容所有浏览器
    document.documentElement.scrollTop = scroll_top;
    window.pageYOffset = scroll_top;
    document.body.scrollTop = scroll_top;
  },
  getTimestamp(num = 13, date) {//获取时间戳
    let _date = date ? new Date(date) : new Date();
    return num == 13 ? _date.getTime() : Math.round(_date.getTime() / 1000);
  },
  formatDate(time, type = '-') {
    function isZero(m) {
      return m < 10 ? '0' + m : m
    }

    var y = time.getFullYear();

    var m = time.getMonth() + 1;

    var d = time.getDate();

    var h = time.getHours();

    var mm = time.getMinutes();

    var s = time.getSeconds();

    console.log(y + type + isZero(m) + type + isZero(d) + ' ' + isZero(h) + ':' + isZero(mm) + ':' + isZero(s))
    return y + type + isZero(m) + type + isZero(d) + ' ' + isZero(h) + ':' + isZero(mm) + ':' + isZero(s);
  },
  formatSecond(s) {//格式化秒
    return `${Math.floor(s / 60 / 60 / 24)}天${Math.floor(s / 60 / 60) % 24}时${Math.floor(s / 60) % 60}分${s % 60}秒`
  },
  testPhoneNumber(value) {//验证手机号码
    return /^1\d{10}$/.test(value)
  },
  testEmail(value) {
    let myReg = /^[-_A-Za-z0-9]+@([_A-Za-z0-9]+.)+[A-Za-z0-9]{2,3}$/;
    return (myReg.test(value))
  },
  checkIdCard(str) {
    //15位数身份证正则表达式
    let arg1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
    //18位数身份证正则表达式
    let arg2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Z])$/;
    if (str.match(arg1) == null && str.match(arg2) == null) {
      return false;
    } else {
      return true;
    }
  },
  isArray(o) {//判断是否为数组
    return Object.prototype.toString.call(o) == '[object Array]';
  },

  /**
   *  把html转义成HTML实体字符
   * @param str
   * @returns {string}
   * @constructor
   */
  htmlEncode(str) {
    var s = "";
    if (str.length === 0) {
      return "";
    }
    s = str.replace(/&/g, "&amp;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/ /g, "&nbsp;");
    // eslint-disable-next-line no-useless-escape
    s = s.replace(/\'/g, "&#39;");//IE下不支持实体名称
    // eslint-disable-next-line no-useless-escape
    s = s.replace(/\"/g, "&quot;");
    return s;
  },

  /**
   *  转义字符还原成html字符
   * @param str
   * @returns {string}
   * @constructor
   */
  htmlRestore(str) {
    var s = "";
    if (str.length === 0) {
      return "";
    }
    s = str.replace(/&amp;/g, "&");
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&nbsp;/g, " ");
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, "\"");
    return s;
  },
  logout() {
    if (window.location.href.indexOf('localhost') !== -1) {
      location.replace('http://localhost:8080/#/login')
      return
    }
    // source 1官网 2易找标 3易考通 4易采通
    location.replace(`${this.getSsoUrl()}?logout=1&source=2&returnUrl=${encodeURIComponent(window.location.href)}`)
  },
  getSsoUrl() {
    let url = "https://adminsso.caigou2003.com/#/"
    if (window.location.hostname.indexOf('dev') !== -1) {
      url = "https://devadminsso.caigou2003.com/#/"
    }
    if (window.location.hostname.indexOf('test') !== -1) {
      url = "https://testadminsso.caigou2003.com/#/"
    }
    return url
  },
  /**
   * 保存 blob
   * filename 想要保存的文件名称
   */
  saveAs(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    }
  },
  numberWithCommas(x) {
    if (!!+x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{4})+(?!\d))/g, ",");
    } else {
      return 0
    }
  },
  bigNumberTransform(value, type) {
    const newValue = ['', '', '']
    let fr = 1000
    let num = 3
    let text1 = ''
    let text2 = ''
    let fm = 1
    if (value == '' || value == null || isNaN(value)) {
      return !type ? newValue : ''
    }
    if (value < 0) {
      value = Math.abs(value);
      text2 = '-'
    }
    while (value / fr >= 1) {
      fr *= 10
      num += 1
    }
    if (num <= 4) { // 千
      newValue[0] = value
      newValue[1] = ''
    } else if (num <= 8) { // 万
      // text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
      text1 = '万'
      fm = text1 === '万' ? 10000 : 10000000
      if (value % fm === 0) {
        newValue[0] = parseInt(value / fm) + ''
      } else {
        newValue[0] = parseFloat(value / fm).toFixed(2) + ''
      }
      newValue[1] = text1
    } else { // 亿 if (num <= 16)
      // text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
      text1 = '亿'
      text1 = (num - 8) / 4 > 1 ? '万亿' : text1
      text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
      text1 = (num - 8) / 10 > 1 ? '亿亿' : text1
      // tslint:disable-next-line:no-shadowed-variable
      fm = 1
      if (text1 === '亿') {
        fm = 100000000
      } else if (text1 === '千亿') {
        fm = 100000000000
      } else if (text1 === '万亿') {
        fm = 1000000000000
      } else if (text1 === '千万亿') {
        fm = 1000000000000000
      } else {
        fm = 1000000000000000000
      }
      if (value % fm === 0) {
        newValue[0] = parseInt(value / fm) + ''
      } else {
        newValue[0] = parseFloat(value / fm).toFixed(2) + ''
      }
      newValue[1] = text1
    }
    if (value < 1000) {
      newValue[0] = value + ''
      newValue[1] = '元'
    }
    newValue[0] = text2 ? text2 + newValue[0] : newValue[0]
    return !type ? newValue : (newValue[0] + newValue[1])
  },
  /**
   * 将对象中的空字符串变为null
   * @param obj
   */
  formatObj(obj) {
    let tempObj = {...obj}
    for (let key in obj) {
      if (tempObj[key] === '') tempObj[key] = null
    }
    return tempObj
  }
}